<template>
  <div class="collect_page">
  
    <div class="collect_box">
     <ListContent />
   </div>

   <div class="page-footer">
      
      <div class="footer-name">洛阳市隋唐城遗址博物馆</div>
      <div class="footer-label">©2023 洛阳汉魏隋唐都城遗址保护中心 豫ICP备2023024382号-1</div>
    </div>
  </div>
   
</template>



<script>

import ListContent from "@/components/listContent";
export default {
  name: "Product",
  components: {
    ListContent,
  },
  setup() {
    return {};
  },
};
</script>



<style scoped>

.page-footer{
    margin-top: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    
}

.page-footer .footer-name{
    font-size: 14px;
    color: #969696;
    margin-right: 16px;
}

.page-footer .footer-label{
    font-size: 12px;
    color: #969696;
}
</style>